import { AI_API_HEADERS, AI_API_ROOT, AI_CURRENT_USER, AI_CURRENT_USER_AVATAR, AI_MESSAGES_INTERCEPTOR } from '@aston/ai-chat';
import { DEBUG_BAR_CONFIG, ScrolledByService, DebugBarConfig, mapToFullNameString, UserSessionService } from '@aston/foundation';
import { ErrorHandler } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map } from 'rxjs';

import { CONSOLE_API_ROOT, ConsoleAIChatBoxMessagesInterceptor, WebSocketService } from './shared-module/services';
import { AuthenticationService } from './authentication-module/services';
import { AuthInterceptor } from './authentication-module/interceptors';
import { AppStoreSelectors } from './root-store/app-store';
import { AppErrorHandler } from './shared-module/handlers';
import { AppConfiguration } from './app.configuration';

export function provideDebugBar() {
	return [{
		provide: DEBUG_BAR_CONFIG,
		useFactory: (
			errorHandler: ErrorHandler,
			configuration: AppConfiguration,
			scrollService: ScrolledByService,
			store: Store,
			auth: AuthenticationService,
			websocket: WebSocketService,
			sessions: UserSessionService,
		): DebugBarConfig => ({
			configuration,
			scrollService,
			errors: errorHandler as AppErrorHandler,
			tenant$: store.select(AppStoreSelectors.selectUser).pipe(filter(Boolean),map(u => ({ id: u.id, name: mapToFullNameString(u.fullName) }))),
			sessionId$: sessions.sessionID$,
			websocket,
			auth,
		}),
		deps: [
			ErrorHandler,
			AppConfiguration,
			ScrolledByService,
			Store,
			AuthenticationService,
			WebSocketService,
			UserSessionService,
		]
	}]
}

export function provideAIChat() {
	return [
		{ provide: AI_CURRENT_USER_AVATAR, useFactory: (store: Store) => store.select(AppStoreSelectors.selectCurrentUserAvatar), deps: [Store] },
		{ provide: AI_CURRENT_USER, useFactory: (store: Store) => store.select(AppStoreSelectors.selectUser), deps: [Store] },
		{ provide: AI_API_ROOT, useExisting: CONSOLE_API_ROOT },
		{ provide: AI_API_HEADERS, useFactory: (int: AuthInterceptor) => int.getAuthHeaders(), deps: [AuthInterceptor] },
		{ provide: AI_MESSAGES_INTERCEPTOR, useClass: ConsoleAIChatBoxMessagesInterceptor },
	]
}